import {
  CModal,
  CModalBody,
  CModalFooter,
  CFormLabel,
  CAccordion,
  CFormInput,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CModalHeader,
  CModalTitle,
  CCol,
  CCard,
  CCardBody,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CTable,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CBadge,
} from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import PatientInfo from './PatientInfo.jsx'
import './Patient.css'
import './dashboard.css'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Select from 'react-select'
import AddPatientForm from './AddNewPatient'
import SavePatients from '../../services/general/savePatientinformation.api'
import InsuranceTab from './InsuaranceTab.jsx'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api.js'

import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import PatientPopup from './PatientPopup.jsx'
import { motion } from 'framer-motion'
import { FunnelPlotOutlined } from '@ant-design/icons'
import { AlignLeft, FilePenLineIcon, Info, Table2, X } from 'lucide-react'
import { HiEye, HiPencil, HiTrash } from 'react-icons/hi'
import PatientAllDetails from './PatientAllDetails.jsx'
import SaveExtra from '../../services/general/saveExtraData.api.js'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config.js'
import { CircularProgress } from '@mui/material'
import Pageloader from '../../components/shared/Pageloader.jsx'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'
import PatientAppointmentDetails from '../../services/general/appointmentData.api.js'
import { formatFacilityOption, getPatientFacilityParentCompany } from '../../utils/facilityParentCompany'
import { patientMatchesSearch } from '../../utils/searchUtils'

const getPatientSortName = (patient) =>
  [patient?.FirstName, patient?.MiddleName, patient?.LastName]
    .filter(Boolean)
    .join(' ')
    .trim()
    .toLowerCase()

const sortPatientsByName = (patients) =>
  [...patients].sort((patientA, patientB) =>
    getPatientSortName(patientA).localeCompare(getPatientSortName(patientB), undefined, {
      sensitivity: 'base',
    }),
  )

const parseApiData = (response, fallback = []) => {
  try {
    return JSON.parse(response?.d)?.Data ?? fallback
  } catch (error) {
    return fallback
  }
}

const parseInsuranceDetails = (insuranceDetails) => {
  try {
    const parsed = JSON.parse(insuranceDetails || '[]')
    if (Array.isArray(parsed)) return parsed[0] || null
    return parsed || null
  } catch (error) {
    return null
  }
}



const normalizePatientText = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase()

const normalizePatientDate = (value) => {
  if (!value) return ''

  const rawValue = String(value).trim()
  const isoDate = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (isoDate) return `${isoDate[1]}-${isoDate[2]}-${isoDate[3]}`

  const parsedDate = new Date(rawValue)
  if (Number.isNaN(parsedDate.getTime())) return rawValue.toLowerCase()

  const yyyy = parsedDate.getFullYear()
  const mm = String(parsedDate.getMonth() + 1).padStart(2, '0')
  const dd = String(parsedDate.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

const getPatientDuplicateKey = (patient, roomNumber) => {
  const patientName = [patient?.FirstName, patient?.MiddleName, patient?.LastName].map(normalizePatientText).filter(Boolean).join(' ')

  return [patientName, normalizePatientDate(patient?.DOB), normalizePatientText(roomNumber ?? patient?.Room)].join('|')
}

const Patient = () => {
  const [patientTheme, setPatientTheme] = useState(() => localStorage.getItem('provio_theme') || 'dark')
  const [patientIDClicked, setPatientIDClicked] = useState(-1)
  const [rowClicked, setRowClicked] = useState(null)
  const [selectedFacility, setSelectedFacility] = useState({})
  const [boxView, setBoxView] = useState('table')
  const [roomNumber, setRoomNumber] = useState('')
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [addedInsurances, setAddedInsurances] = useState([])
  const [insuranceList, setInsuranceList] = useState([])
  const [selectedDetails, setSelectedDetails] = useState({})
  const [activeTab, setActiveTab] = useState('patientDetails')
  const buttonList = [{ Name: 'View' }, { Name: 'Edit' }, { Name: 'Delete' }]
  const [patientID, setPatientID] = useState('')
  const [diagnosisData, setDiagnosisData] = useState([])
  var selectedDiagnosis = []
  const [allSelectedDiagnosis, setAllSelectedDiagnosis] = useState([])
  const [facilities, setFacilities] = useState([])
  const [patientData, setPatientData] = useState([])
  const [patientCount, setPatientCount] = useState(-1)
  const [viewPatientDetail, setViewPatientDetail] = useState()
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [patientModelVisible, setPatientModalVisible] = useState(false)
  const [dataCallType, setDataCallType] = useState(null)
  const [setDataId, setEditDataId] = useState(null)
  const [showPatientInfo, setShowPatientInfo] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deletePatientID, setDeletePatientID] = useState(null)
  const [noteID, setNoteID] = useState(null)
  const [allPatientVisible, setAllPatientVisible] = useState(false)
  const [showNotePatient, setShowNotePatient] = useState(false)
  const [allAppointment, setAllAppointment] = useState([])
  const [samePatientExist, setSamePatientExist] = useState(false)
  const patientStatusList = [
    { value: 1, label: 'New Patient' },
    { value: 2, label: 'Follow Up' },
    { value: 3, label: 'Re-Admit' },
    { value: 4, label: 'Discharge' },
  ]

  const [selectedStatusPatient, setSelectedStatusPatient] = useState({ value: 1, label: 'New Patient' })
const serviceOptions = React.useMemo(() => {
  const facilityType = String(
    selectedFacility?.Type || selectedFacility?.type || ''
  ).trim()

  if (!facilityType.toUpperCase().startsWith('CCRC')) {
    return []
  }

  const [, services = ''] = facilityType.split(':')

  return services
    .split(',')
    .map(item => item.trim())
    .filter(Boolean)
    .map(item => ({
      value: item,
      label: item,
    }))
}, [selectedFacility])
  useEffect(() => {
    const handleThemeChange = () => {
      setPatientTheme(localStorage.getItem('provio_theme') || 'dark')
    }

    window.addEventListener('storage', handleThemeChange)
    window.addEventListener('provio-theme-change', handleThemeChange)

    return () => {
      window.removeEventListener('storage', handleThemeChange)
      window.removeEventListener('provio-theme-change', handleThemeChange)
    }
  }, [])

  const [childformData, setChildFormData] = useState({
    FirstName: '',
    MiddleName: '',
    LastName: '',
    DOB: '',
    Gender: '',
    Age: '1',
    PhoneNumber: '',
    EmergencyName: '',
    EmergencyPhone: '',
    Address: '',
    State: '',
    City: '',
    ZipCode: '',
    Country: '',
    insurance: '',
    Status: 'NewPatient',
    patientType: '',
    services: '',
  })

  const resetStates = () => {
    setChildFormData({
      FirstName: '',
      MiddleName: '',
      LastName: '',
      DOB: '',
      Gender: '',
      Age: '1',
      PhoneNumber: '',
      EmergencyName: '',
      EmergencyPhone: '',
      Address: '',
      State: '',
      City: '',
      ZipCode: '',
      Country: '',
      insurance: '',
      Status: 'NewPatient',
      patientType: '',
      services: '',
    })
    setRoomNumber('')
    // setSelectedFacility({})
    setAddedInsurances([])
    setInsuranceList([])
    setSelectedDetails({})
    setAllSelectedDiagnosis([])
    setModalVisible(false)
  }

  const getPatientInsurances = async (patientID) => {
    if (!patientID) return []

    const patientInsurance = await PatientInsuranceFn('SELECT', '', patientID)
    return parseApiData(patientInsurance, [])
  }

  const patientSelected = async (type, rowSelected, showModule = true) => {
    if (!rowSelected?.PatientID && type !== 'DETAIL') {
      toast.error('Patient details not found. Please refresh and try again.', toastConfig)
      return
    }

    getData()
    setViewPatientDetail(rowSelected)
    console.log('rowSelected', rowSelected)
    setActiveTab('patientDetails')

    if (type === 'EDIT') {
      const selectedPatient = getPatientPayload(rowSelected)
      const patientInsurance = await getPatientInsurances(selectedPatient.PatientID || rowSelected.PatientID)

      setPatientID(selectedPatient.PatientID || rowSelected.PatientID)
      try {
        let tempSelectedDiagnosis = selectedPatient.Diagnosis ? selectedPatient.Diagnosis.split(',') : []
        selectedDiagnosis = diagnosisData.filter((obj) => tempSelectedDiagnosis.includes(obj.label))
        setRoomNumber(selectedPatient?.Room || rowSelected?.Room || '')
        const matchedFacilityFromPatient = getFacilityOptionFromPatient(selectedPatient)
        console.log('matchedFacilityFromPatient', matchedFacilityFromPatient, facilities,selectedPatient)
        setSelectedFacility(matchedFacilityFromPatient || facilities[0] || {})
        setAllSelectedDiagnosis(selectedDiagnosis)
      } catch (e) {
        setAllSelectedDiagnosis([])
      }

      const existingPatientType =
        getPatientTypeForPatient(selectedPatient) || getPatientTypeForPatient(rowSelected) || ''

      const existingService = getPatientServiceForPatient(selectedPatient) || getPatientServiceForPatient(rowSelected) || ''

      setChildFormData({
        FirstName: selectedPatient.FirstName || rowSelected.FirstName || '',
        MiddleName: selectedPatient.MiddleName || rowSelected.MiddleName || '',
        LastName: selectedPatient.LastName || rowSelected.LastName || '',
        DOB: selectedPatient.DOB || rowSelected.DOB || '',
        Gender: selectedPatient.Gender || rowSelected.Gender || '',
        Age: selectedPatient.Age || rowSelected.Age || '0',
        PhoneNumber: selectedPatient.PhoneNumber || rowSelected.PhoneNumber || '',
        EmergencyName: selectedPatient.EmergencyName || rowSelected.EmergencyName || '',
        EmergencyPhone: selectedPatient.EmergencyPhone || rowSelected.EmergencyPhone || '',
        Address: selectedPatient.Address || rowSelected.Address || '',
        State: selectedPatient.State || rowSelected.State || '',
        City: selectedPatient.City || rowSelected.City || '',
        ZipCode: selectedPatient.ZipCode || rowSelected.ZipCode || '',
        Country: selectedPatient.Country || rowSelected.Country || '',
        Status: selectedPatient.Status || rowSelected.Status || '',
        patientType: existingPatientType,
        services: existingService,
      })

      setSelectedDetails({ Insurances: patientInsurance })
      if (showModule) {
        setModalVisible(true)
      }
    } else if (type === 'DELETE') {
      setDeleteVisible(true)
      setDeletePatientID(rowSelected?.PatientID)
    } else if (type === 'VIEW') {
      const patientInsurance = await getPatientInsurances(rowSelected.PatientID)

      setSelectedDetails({ Insurances: patientInsurance })
      setViewModalVisible(true)
    } else if (type === 'patientDetailsView') {
      const patientInsurance = await getPatientInsurances(rowSelected.PatientID)

      setSelectedDetails({ Insurances: patientInsurance })
      setAllPatientVisible(true)
    } else {
      setPatientIDClicked(rowSelected?.PatientID)
      setRowClicked(rowSelected)
      setPatientModalVisible(true)
    }
  }

  const patientDataFn = async () => {
    setIsPageLoading(true)
    try {
      let Appointment = await getAppointmentData()
      let patientData = await SavePatients('GetAll', '', '', '')
      const patients = parseApiData(patientData, [])
      console.log('patients getall', patientData)
      setPatientData(patients)
      setPatientCount(patients.length)
    } catch (error) {
    } finally {
      setIsPageLoading(false)
    }
  }

  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = parseApiData(a, [])
    let options = []
    data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)

    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = parseApiData(insuranceData, [])

    const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((ins) => ins.Type)))
    setInsuranceList(insuranceData)
    setInsuranceTypes(uniqueInsuranceTypes)
  }

  const getFacilities = async () => {
    try {
      let a = await FacilityCRUD('SELECT', {})
      if (a && a.d) {
        let data = JSON.parse(a.d)?.Data
        const formattedData = data.map(formatFacilityOption)
        setFacilities(formattedData)
        setSelectedFacility(formattedData[0])
      } else {
        console.error('Failed to fetch facilities: Invalid API response', a)
      }
    } catch (e) {
      console.error('Error parsing facilities:', e)
    }
  }

  const normalizeString = (value = '') => String(value || '').trim().toLowerCase()

  const getPatientPayload = (patient = {}) => {
    console.log('getPatientPayload patient', patient)
    if (Array.isArray(patient.Data) && patient.Data.length > 0) {
      return patient.Data[0] || patient
    }
    if (patient.data && typeof patient.data === 'object' && Object.keys(patient.data).length > 0) {
      return patient.data
    }
    return patient
  }

  const getFacilityOptionFromPatient = (patient = {}) => {
    const payload = getPatientPayload(patient)
    const facilityId = normalizeString(payload.FacilityID || payload?.FacilityID || payload.value)
    const facilityName = normalizeString(payload.FacilityName || payload?.FacilityName || payload.label)
    const matchedFacility = facilities.find((item) => {
      const optionId = normalizeString(item.value || item.ID || item.FacilityID)
      const optionLabel = normalizeString(item.label || item.Name || item.FacilityName)
      return (facilityId && optionId && facilityId === optionId) || (facilityName && optionLabel && facilityName === optionLabel)
    })

    if (matchedFacility) return matchedFacility
    if (!facilityId && !facilityName) return null

    return {
      value: payload.FacilityID || payload?.FacilityID || payload.value || '',
      label: payload.FacilityName || payload?.FacilityName || payload.label || '',
      Type: String(payload.FacilityType || payload.Type || '').trim(),
      parentCompany: getPatientFacilityParentCompany(payload, facilities),
    }
  }

  const getMatchingFacilityOption = (facility = {}, facilityOptions = []) => {
    const facilityId = normalizeString(facility?.FacilityID || facility?.value)
    const facilityName = normalizeString(facility?.FacilityName || facility?.label)
    return facilityOptions.find((item) => {
      const optionId = normalizeString(item.value || item.ID || item.FacilityID)
      const optionLabel = normalizeString(item.label || item.Name || item.FacilityName)
      return (facilityId && optionId && facilityId === optionId) || (facilityName && optionLabel && facilityName === optionLabel)
    })
  }

  const getFacilityTypeForPatient = (patient = {}) => {
    const payload = getPatientPayload(patient)
    const directType = String(payload.Type || payload.FacilityType || '').trim()
    if (directType) return directType

    const facilityOption = getFacilityOptionFromPatient(payload)
    return String(facilityOption?.Type || facilityOption?.type || '').trim()
  }

  const getPatientTypeForPatient = (patient = {}) => {
    const payload = getPatientPayload(patient)
    const rawTypeValue =
      payload.PatientType ||
      payload.patientType ||
      payload.Patient_Type ||
      payload.patient_type ||
      payload.Term ||
      payload.term ||
      payload.patientTerm ||
      payload.patient_term ||
      ''

    return resolvePatientTypeValue(rawTypeValue)
  }

  const getPatientServiceForPatient = (patient = {}) => {
    const payload = getPatientPayload(patient)
    return String(
      payload.Service ||
      payload.service ||
      payload.Services ||
      payload.services ||
      '',
    ).trim()
  }

  const normalizePatientType = (value) => {
    const normalized = normalizeString(value).replace(/[^a-z]/g, '')
    return normalized
  }

  const resolvePatientTypeValue = (value) => {
    const normalized = normalizePatientType(value)
    if (normalized.includes('short')) return 'Short Term'
    if (normalized.includes('long')) return 'Long Term'

    const option = patientTypeOptions.find((opt) => normalizePatientType(opt.value) === normalized)
    return option ? option.value : ''
  }

  const [modalVisible, setModalVisible] = useState(false)
  const [viewModalVisible, setViewModalVisible] = useState(false)

  const handleonClick = () => {
    setModalVisible((e) => !e), setActiveTab('patientDetails')
  }

  const [creatingPatientLoader, setCreatingPatientLoader] = useState(false)
  const [formValidationErrors, setFormValidationErrors] = useState({})

  const selectedFacilityType = String(
  selectedFacility?.Type || selectedFacility?.type || ''
).trim()

const normalizedFacilityType = selectedFacilityType.toLowerCase()

// Patient Type should show for these facility types
const showPatientType = ['ccrc', 'alf', 'mc', 'ilf', 'snf'].some((type) =>
  normalizedFacilityType.includes(type)
)
const isCCRCFacility = selectedFacilityType
  .toLowerCase()
  .startsWith('ccrc')
const shouldShowServicesDropdown = isCCRCFacility
  const patientTypeOptions = [
    { value: 'Short Term', label: 'Short Term' },
    { value: 'Long Term', label: 'Long Term' },
  ]


  const validatePatientForm = () => {
    let isValid = true
    let errors = {}

    if (!childformData.FirstName?.trim()) {
      errors.FirstName = 'First Name is required'
      isValid = false
    }

    if (!childformData.LastName?.trim()) {
      errors.LastName = 'Last Name is required'
      isValid = false
    }

    if (!childformData.DOB) {
      errors.DOB = 'Date of Birth is required'
      isValid = false
    }

    if (!roomNumber?.trim()) {
      errors.roomNumber = 'Room Number is Required'
      isValid = false
    }

   

    setFormValidationErrors(errors)
    return isValid
  }

  const saveDiagnosisData = async (patientCustomData) => {
    const isValid = validatePatientForm()
    // if (!isValid) {
    //   toast.error('Please fill all required fields', toastConfig)
    //   return
    // } m

    if (!isValid) {
      // Collect all missing required fields
      const missingFields = []

      if (!childformData.FirstName?.trim()) missingFields.push('First Name')
      if (!childformData.LastName?.trim()) missingFields.push('Last Name')
      if (!childformData.DOB) missingFields.push('Date of Birth')
      if (!roomNumber?.trim()) missingFields.push('Room Number')
     

      const errorMessage = `Please fill all required fields: ${missingFields.join(', ')}`
      toast.error(errorMessage, toastConfig)
      return
    }

    setCreatingPatientLoader(true)
    try {
      let a = {}
      try {
        a['FacilityID'] = selectedFacility?.value.toString()
        a['FacilityName'] = selectedFacility?.label.toString()
        a['Room'] = roomNumber.toString()
        a['FacilityType'] = String(selectedFacility?.Type || selectedFacility?.type || '').toString()
        a['patientType'] = childformData.patientType || ''
        a['Services'] = childformData.services || ''
      } catch (e) {
        a['FacilityID'] = ''
        a['FacilityName'] = ''
        a['Room'] = -1
        a['FacilityType'] = ''
        a['patientType'] = ''
        a['Services'] = ''
      }

      let allDiagnosis = allSelectedDiagnosis
        .map((obj) => {
          return obj.label
        })
        .join(',')
      let insurances = addedInsurances?.map((ins) => ({
        InsuranceID: ins?.ID,
      }))

      // check same name patient exist or not

      // return

      let savePatientInfo
      if (patientID === '') {
        const duplicateKey = getPatientDuplicateKey(childformData, roomNumber)
        const findPatientSame = patientData.find((item) => getPatientDuplicateKey(item) === duplicateKey)
        if (findPatientSame) {
          toast.error('Duplicate Patient Found. Same Name, DOB, and Room Number already exist.', toastConfig)
          setSamePatientExist(true)
          setCreatingPatientLoader(false)
          return
        }
        let saveInsurance = await PatientInsuranceFn('INSERT', JSON.stringify(addedInsurances), '')
        const today = new Date()
        const mm = String(today.getMonth() + 1).padStart(2, '0')
        const dd = String(today.getDate()).padStart(2, '0')
        const yyyy = today.getFullYear()
        const formattedDate = `${mm}/${dd}/${yyyy}`
        savePatientInfo = SavePatients('Insert', JSON.stringify({ ...childformData, createdDate: formattedDate }), JSON.stringify(a), allDiagnosis, -1, JSON.stringify(insurances))
      } else {
        let saveInsurance = await PatientInsuranceFn('UPDATE', JSON.stringify(addedInsurances), patientID)
        savePatientInfo = SavePatients('Update', JSON.stringify(patientCustomData ? patientCustomData : childformData), JSON.stringify(a), allDiagnosis, patientID, JSON.stringify(insurances))
      }

      await savePatientInfo

      const optimisticPatient = {
        ...childformData,
        PatientID: patientID === '' ? `temp-${Date.now()}` : patientID,
        FacilityName: selectedFacility?.label || '',
        FacilityType: String(selectedFacility?.Type || selectedFacility?.type || '').trim(),
        Room: roomNumber,
        Diagnosis: allDiagnosis,
        patientType: childformData.patientType || '',
        services: childformData.services || '',
      }

      if (patientID === '') {
        setPatientData((prev) => [optimisticPatient, ...prev])
        toast.success('Patient Added Successfully', toastConfig)
      } else {
        setPatientData((prev) => prev.map((p) => (p.PatientID === patientID ? { ...p, ...optimisticPatient } : p)))
        toast.success('Patient Updated Successfully', toastConfig)
      }

      resetStates()
      setPatientID('')
      setCreatingPatientLoader(false)

      patientDataFn()
    } catch (error) {
      setCreatingPatientLoader(false)
      toast.error('Failed to save patient data. Please try again.', toastConfig)
    }
  }

  useEffect(() => {
    getData()
    patientDataFn()
    getFacilities()
    // getAppointmentData();
  }, [])

  // if (rowClicked) {
  //   let provideInformation = rowClicked.Diagnosis.split(',');
  //   let information = provideInformation.map((item) => {
  //     return (
  //       { diagnosis: item, information: 'patient' }
  //     )
  //   })

  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     information,
  //   }

  // }

  const getAppointmentData = async () => {
    setIsPageLoading(true)
    try {
      const result = await PatientAppointmentDetails('GET', '', '', '', '')

      const rawData = JSON.parse(result.d)?.Data || []

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.AppointmentDetails)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current }
            })

            structuredData.push({
              patientID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
          console.warn('Unexpected non-array parsed data:', parsedList)
        }
      })

      setAllAppointment(structuredData)
      let flatAppointments = structuredData.flatMap((p) => p.appointmentDetails)

      return flatAppointments
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const getLatestData = async () => {
    try {
      const result = await PatientAppointmentDetails('GET', '', '', '', '')

      // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '')
      const rawData = JSON.parse(result.d)?.Data || []

      return rawData.map((item) => {
        return {
          ...item,
          AppointmentDetails: JSON.parse(item?.AppointmentDetails),
        }
      })
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
    }
  }
  const handleDeleteAppointment = async () => {
    if (!deletePatientID) {
      toast.error('delete ID not found', toastConfig)
      return // stop execution if no ID
    }

    try {
      const latestData = await getLatestData()

      // Get schedules that contain the patient
      const filterAppointments = latestData.filter((schedule) => schedule.AppointmentDetails.some((patient) => patient.patientID === deletePatientID))

      if (!filterAppointments.length) {
        // toast.error('Patient not found in any schedule', toastConfig);
        return
      }

      const filterAppointmentWithoutPatientAppointment = filterAppointments.map((item) => ({
        ...item,
        AppointmentDetails: item.AppointmentDetails.filter((patient) => patient.patientID !== deletePatientID),
      }))

      if (!filterAppointmentWithoutPatientAppointment.length) {
        // toast.error('Patient not found in any schedule', toastConfig);
        return
      }

      try {
        await Promise.all(filterAppointmentWithoutPatientAppointment.map((item) => PatientAppointmentDetails('UPDATE', item.ID, item.ScheduleDate, item.ProviderID, JSON.stringify(item.AppointmentDetails), item.CreatedDate)))

        getAppointmentData()
      } catch (error) {
        console.log('error while deleting', error)
      }
    } catch (e) {
      console.error('Error', e)
    }
  }

  const [deleteLoader, setDeleteLoader] = useState(false)


  const handleDeletePatient = async () => {
    if (!deletePatientID) {
      toast.error('Delete ID not found', toastConfig)
      return
    }

    setDeleteLoader(true)

    try {
      const patient = patientData.find(p => p.PatientID === deletePatientID)
      const currentDeleteId = deletePatientID

      await Promise.all([
        backupDeletedPatient(patient),
        removePatientFromAppointments(currentDeleteId),
        deletePatientRecord(currentDeleteId),
      ])

      await patientDataFn()
      setDeleteVisible(false)
      setDeletePatientID(null)
      toast.success('Patient Deleted Successfully', toastConfig)
    } catch (err) {
      console.error(err)
      toast.error('Failed to delete patient', toastConfig)
    } finally {
      setDeleteLoader(false)
    }
  }
  const backupDeletedPatient = async (patient) => {
    if (!patient) return
    await SaveExtra('Insert', 'DeletedPatients', JSON.stringify(patient))
  }
  const removePatientFromAppointments = async (patientID) => {
    const schedules = await getLatestData()

    const updatedSchedules = schedules
      .map(schedule => {
        const filtered = schedule.AppointmentDetails.filter(
          p => p.patientID !== patientID
        )

        if (filtered.length === schedule.AppointmentDetails.length) return null

        return {
          ...schedule,
          AppointmentDetails: filtered,
        }
      })
      .filter(Boolean)

    await Promise.all(
      updatedSchedules.map(item =>
        PatientAppointmentDetails(
          'UPDATE',
          item.ID,
          item.ScheduleDate,
          item.ProviderID,
          JSON.stringify(item.AppointmentDetails),
          item.CreatedDate
        )
      )
    )
  }
  const deletePatientRecord = async (patientID) => {
    await SavePatients('Delete', '', '', '', patientID, '')
  }


  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const [showFilter, setShowFilter] = useState(false)
  const [filterData, setFilterData] = useState({
    facility: [],
    searchValue: '',
    date: '',
    status: [],
  })
  const selectStatusOption = [
    { value: 'NewPatient', label: 'New Patient' },
    { value: 'Follow Up', label: 'Follow Up' },
    { value: 'Re Admit', label: 'Re Admit' },
    { value: 'Discharge', label: 'Discharged' },
  ]

  const selectedOption = selectStatusOption.find((option) => option.value === filterData.status)
  const [filteredPatientData, setFilteredPatientData] = useState([])
  const [groupedUpdatedFilteredPatients, setGroupedUpdatedFilteredPatients] = useState([])

  const [patientListLoad, setPatientListLoad] = useState(false)

  const filteredPatientDataFsn = () => {
    setPatientListLoad(true)
    const totalPatientFiltered =
      patientData.length > 0
        ? patientData
          .map((patient) => ({
            ...patient,
            facilityParentCompany: getPatientFacilityParentCompany(patient, facilities),
          }))
          // ?.filter((item) => item.Status !== 'Discharge')
          .filter((patient) => {
            // Find selected facility labels
            // const selectedFacilityLabels = facilities.filter((facility) => filterData.facility.includes(facility.value)).map((facility) => facility.label)
            const selectedFacilityLabels = new Set(
              facilities
                .filter(f => filterData.facility.includes(f.value))
                .map(f => f.label)
            )
            const matchesFacility = filterData.facility.length === 0 || selectedFacilityLabels.has(patient.FacilityName)

            const matchesStatus = filterData.status.length === 0 || filterData.status.includes(patient.Status)

            const matchesDate = !filterData.date || patient?.DOB === filterData.date

            const matchesSearchValue =
              !filterData.searchValue ||
              patientMatchesSearch(patient, filterData.searchValue, {
                facilityName: patient?.FacilityName,
                facilityParentCompany: patient?.facilityParentCompany,
              })

            return matchesFacility && matchesStatus && matchesSearchValue && matchesDate
          })
        : []

    const sortedPatientFiltered = sortPatientsByName(totalPatientFiltered)

    setFilteredPatientData(sortedPatientFiltered)
    setPatientCount(sortedPatientFiltered?.length)

    const groupedByFacility = {}

    sortedPatientFiltered.forEach((patient) => {
      const facility = patient.FacilityName || 'Unknown'
      if (!facility) return

      if (!groupedByFacility[facility]) {
        groupedByFacility[facility] = []
      }

      groupedByFacility[facility].push(patient)
    })

    setGroupedUpdatedFilteredPatients(groupedByFacility)
    setPatientListLoad(false)
  }

  useEffect(() => {
    filteredPatientDataFsn()
  }, [filterData, patientData, facilities])

  const [toggleAgGrid, setToggleAgGrid] = useState(false)
  useEffect(() => {
    setToggleAgGrid((p) => !p)
  }, [filterData, patientData, facilities])
  const selectedOptionStatus = selectStatusOption.find((option) => option.value === childformData.Status)

  const renderedPatientList = React.useMemo(() => {
    return (
      <div className="hide-drag-table">
        {Object.entries(groupedUpdatedFilteredPatients)
          .sort(([facilityA], [facilityB]) => facilityA.trim().toUpperCase().localeCompare(facilityB.trim().toUpperCase()))
          .map(([facility, patients], facIdx) => {
            console.log('facility', facility, 'patients', patients)
            const parentCompanyName = patients.find((patient) => patient?.facilityParentCompany)?.facilityParentCompany || ''

            return (
              <div key={facility}>
                <CAccordion alwaysOpen className="dashboard-dark-accordion patient-theme-accordion">
                  <CAccordionItem className="border-0 border-bottom my-2 mx-4 dashboard-dark-facility-item patient-theme-facility-item" itemKey={`fac-${facIdx}`}>
                    <CAccordionHeader className="patient-theme-accordion-header" style={{ fontSize: '14px', boxShadow: 'unset' }}>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <span className="text-primary d-flex align-items-center gap-2 flex-wrap">
                          <span>
                            {facility} ({patients?.length || 0}) {parentCompanyName && `- ${parentCompanyName}`}
                          </span>
                        </span>
                      </div>
                    </CAccordionHeader>

                    <CAccordionBody className="border-bottom-0 border-0 py-0 p-0">
                      <CTable className="mb-0 border-bottom-0 border-0 patient-theme-table">
                        <CTableBody>
                          {patients.length > 0 &&
                            patients.map((patient, index) => (
                              <CTableRow
                                className={`order-0 px-4 ${patient.Status === 'NewPatient' ? 'NP' : patient.Status === 'Follow Up' ? 'FU' : patient.Status} patient-row-list`}
                                key={patient.PatientID}
                                style={{
                                  verticalAlign: 'middle',
                                  padding: '20px',
                                  top: 0,
                                }}
                              >
                                <CTableHeaderCell className="border-bottom-0 border-0" scope="row" style={{ width: '100%' }}>
                                  <div
                                    style={{
                                      display: 'grid',
                                      gridTemplateColumns: '260px minmax(0, 1fr)',
                                      alignItems: 'center',
                                      gap: '16px',
                                      width: '100%',
                                    }}
                                  >
                                    <span style={{ paddingLeft: '20px', minWidth: 0 }}>
                                      <span className="patient-name-fixed">{patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}</span>
                                    </span>
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        minWidth: 0,
                                      }}
                                    >
                                      <span className="room-pill" style={{ margin: 0, width: '180px', minWidth: '180px', maxWidth: '180px' }}>
                                        Room No: {patient?.Room}
                                      </span>
                                      <span className="notestatus-pill" style={{ margin: 0 }}>
                                        Gender: {patient?.Gender || 'N/A'}
                                      </span>
                                      <span className="schedule-pill" style={{ margin: 0 }}>
                                        Age: {patient?.Age}
                                      </span>
                                    </div>
                                  </div>
                                </CTableHeaderCell>
                                <CTableDataCell className="d-flex justify-content-end border-bottom-0 border-0">
                                  <div className="button-wrapper d-flex align-items-center gap-2">
                                    <CButton variant="outline" onClick={() => patientSelected('EDIT', patient)} color="warning" className="px-2">
                                      <HiPencil size={20} />
                                    </CButton>
                                    <CButton variant="outline" onClick={() => patientSelected('VIEW', patient)} color="success" className="px-2">
                                      <HiEye size={20} />
                                    </CButton>
                                    <CButton variant="outline" color="danger" onClick={() => patientSelected('DELETE', patient)} className="px-2">
                                      <HiTrash size={20} />
                                    </CButton>
                                    <CButton variant="outline" color="dark" onClick={() => patientSelected('patientDetailsView', patient)} className="px-2">
                                      <FilePenLineIcon size={20} />
                                    </CButton>
                                  </div>
                                </CTableDataCell>
                              </CTableRow>
                            ))}
                        </CTableBody>
                      </CTable>
                    </CAccordionBody>
                  </CAccordionItem>
                </CAccordion>
              </div>
            )
          })}
        {Object.entries(groupedUpdatedFilteredPatients).length === 0 && <h6 className="d-flex justify-content-center text-secondary">No Patient found</h6>}
      </div>
    )
  }, [groupedUpdatedFilteredPatients]) // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <div>
      {showPatientInfo ? (
        <PatientInfo patientID={patientIDClicked} patientData={rowClicked} dataCallType={dataCallType} noteId={0} setEditDataId={setEditDataId} setDataId={setDataId} setDataCallType={setDataCallType} noteID={noteID} />
      ) : setDataId ? (
        <PatientInfo patientID={patientIDClicked} patientData={rowClicked} dataCallType={dataCallType} setDataId={setDataId} noteID={noteID} />
      ) : (
        <div className="position-relative patient-theme-page" data-theme={patientTheme}>
          {filterData?.searchValue === '' ? (
            <Pageloader isLoading={!groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0} />
          ) : (
            <Pageloader isLoading={(!groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0) && patientData.length === 0} />
          )}

          <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme">
            <div className="page-header mb-3">
              <div className="d-flex align-items-center gap-1 patient-theme-toolbar">
                <div className="search-input search-dark dashboard-dark-search">
                  <SearchIcon />
                  <input
                    type="text"
                    value={filterData.searchValue}
                    onChange={(e) => {
                      setFilterData((prev) => ({ ...prev, searchValue: e.target.value }))
                    }}
                    placeholder="Search by Patient or Facility..."
                  />
                </div>

                <div className="position-relative">
                  <Button className="d-flex align-items-center gap-2 dashboard-dark-filter-button" variant="outlined" size="large" onClick={() => setShowFilter(!showFilter)}>
                    <FunnelPlotOutlined />
                    Filter
                  </Button>

                  {showFilter && (
                    <motion.div
                      initial={{ opacity: 0, y: 4 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 4 }}
                      transition={{ duration: 0.3, ease: 'easeInOut' }}
                      style={{
                        width: '300px',
                        zIndex: 50,
                      }}
                      className="position-absolute gap-1 d-flex flex-column top-full left-0 z-10 shadow-lg p-4 rounded-md dashboard-dark-filter-popover patient-theme-filter-popover"
                    >
                      <div>
                        <CFormLabel>Select Facility</CFormLabel>
                        <Select
                          placeholder="Select"
                          name="facility"
                          options={facilities}
                          value={facilities.filter((fac) => filterData.facility.includes(fac.value))}
                          isMulti
                          isClearable
                          onChange={(selectedOptions) =>
                            setFilterData((prev) => ({
                              ...prev,
                              facility: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                            }))
                          }
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </div>

                      <div className="mt-3">
                        <CFormLabel>Select Patient Status</CFormLabel>
                        <Select
                          name="status"
                          isMulti
                          placeholder="Select"
                          options={selectStatusOption}
                          isClearable
                          value={selectStatusOption.filter((option) => filterData.status.includes(option.value))}
                          onChange={(selectedOptions) =>
                            setFilterData((prev) => ({
                              ...prev,
                              status: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                            }))
                          }
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </div>

                      <div className="mt-2" style={{ postion: 'relative' }}>
                        <CFormLabel>Select DOB</CFormLabel>
                        <div>
                          <CustomDatePickingFormat
                            value={filterData.date || ''}
                            aria-describedby="exampleFormControlInputHelpInline"
                            onChange={(e) => {
                              setFilterData((p) => ({
                                ...p,
                                date: e, // Keep the date in "YYYY-MM-DD" format
                              }))
                            }}
                          />
                        </div>
                        {/* <CFormInput
                          type="date"
                          color="primary"
                          // value={filterData.date || ''}
                          aria-describedby="exampleFormControlInputHelpInline"
                          onChange={(e) => {
                            setFilterData((p) => ({
                              ...p,
                              date: e.target.value, // Keep the date in "YYYY-MM-DD" format
                            }))
                          }}
                        /> */}
                        {filterData.date && (
                          <button
                            onClick={() => setFilterData((p) => ({ ...p, date: '' }))}
                            style={{
                              position: 'absolute',
                              left: '132px',
                              zIndex: 2022220,
                              top: '66%',
                              width: '20px',
                              height: '20px',
                              transform: 'translateY(-50%)',
                              border: 'none',
                              cursor: 'pointer',
                            }}
                            className="d-flex align-items-center justify-content-center patient-theme-date-clear"
                          >
                            <X className="" strokeWidth={3} size={30} />
                          </button>
                        )}
                      </div>
                      <Button className="mt-3" onClick={() => setShowFilter(false)} variant="outlined">
                        Close
                      </Button>
                    </motion.div>
                  )}
                </div>

                <Button className="mx-1 dashboard-dark-add-button" variant="contained" onClick={handleonClick}>
                  <span className="dashboard-dark-add-button__label">+ Add&nbsp;Patient</span>
                </Button>
              </div>
              <div className="d-flex align-items-center">
                <div className="display-total-patient mx-2">
                  <span className="mx-1">{patientCount}</span> Patients
                </div>
                <div className="d-flex align-items-center justify-content-end gap-1 pl-3 ">
                  <CButton
                    onClick={() => {
                      setBoxView('table')
                    }}
                    style={{
                      height: '40px',
                      padding: '5px 10px',
                    }}
                    color={boxView === 'table' ? 'primary' : 'light'}
                    className={`d-flex align-items-center justify-content-center patient-theme-view-toggle ${boxView === 'table' ? 'patient-theme-view-toggle--active' : ''}`}
                  >
                    <Table2 size={16} strokeWidth={1.25} />
                    <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>List</div>
                  </CButton>
                  <CButton
                    onClick={() => {
                      setBoxView('list')
                    }}
                    style={{
                      height: '40px',
                      padding: '5px 10px',
                      marginRight: '10px',
                    }}
                    color={boxView === 'list' ? 'primary' : 'light'}
                    className={`d-flex align-items-center justify-content-center patient-theme-view-toggle ${boxView === 'list' ? 'patient-theme-view-toggle--active' : ''}`}
                  >
                    <AlignLeft size={16} strokeWidth={1.25} />
                    <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>Details</div>
                  </CButton>
                </div>
              </div>
            </div>
            {boxView === 'list' && (
              <div className=" d-flex flex-wrap" style={{ padding: '0px 0px!important', gap: '20px' }}>
                {patientData &&
                  filteredPatientData.map((patient, index) => (
                    <div key={index} className="custom-card">
                      <div className="card-header">
                        <div>
                          <span className="d-flex align-items-center gap-2">
                            {/* <span className=""
                                style={{
                                  width: "12px",
                                  borderRadius: "50px",
                                  height: "12px",
                                  backgroundColor: patient.Status === 'NewPatient' ? 'green' : patient.Status === 'Follow Up' ? 'orange' : 'blue',
                                }}
                              ></span> */}
                            <p className="name-block d-flex align-items-center gap-1">
                              {patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}
                              <span
                                className={`patient-theme-status-badge ${
                                  patient.Status === 'NewPatient'
                                    ? 'patient-theme-status-badge--new'
                                    : patient.Status === 'Follow Up'
                                      ? 'patient-theme-status-badge--followup'
                                      : 'patient-theme-status-badge--readmit'
                                }`}
                              >
                                ({patient.Status === 'Follow Up' ? 'Follow Up' : patient.Status === 'NewPatient' ? 'New Patient' : patient.Status === 'Discharge' ? 'Discharge' : 'Re Admit'})
                              </span>
                            </p>
                          </span>
                          <div className="bullet-points">
                            <span>{patient.Gender}</span>
                            {patient?.DOB && (
                              <span>
                                DOB:{' '}
                                {new Date(patient.DOB).toLocaleDateString('en-US', {
                                  month: '2-digit',
                                  day: '2-digit',
                                  year: 'numeric',
                                })}
                              </span>
                            )}
                            <span>{patient.Age} Years</span>
                          </div>
                        </div>
                        <div className="button-wrapper">
                          {/* <button
                            style={{
                              // color : "yellow",
                              // borderColor:"yellow"
                            }}
                            className="edit-button" onClick={() => patientSelected('EDIT', patient)}><EditIcon /></button> */}
                          {/* <CButton variant='outline' color='success'><EditIcon /></CButton> */}
                          <CButton variant="outline" onClick={() => patientSelected('EDIT', patient)} color="warning" className="px-2">
                            <HiPencil size={20} />
                          </CButton>
                          <CButton variant="outline" onClick={() => patientSelected('VIEW', patient)} color="success" className="px-2">
                            <HiEye size={20} />
                          </CButton>
                          <CButton variant="outline" color="danger" onClick={() => patientSelected('DELETE', patient)} className="px-2">
                            <HiTrash size={20} />
                          </CButton>
                          <CButton variant="outline" color="dark" onClick={() => patientSelected('patientDetailsView', patient)} className="px-2">
                            <FilePenLineIcon size={20} />
                          </CButton>

                          {/* <button className="info-button" onClick={() => patientSelected('DETAIL', patient)}><Info fill="" /></button> */}

                          {/* <button 
                            style={{
                              color : "green",
                              borderColor:"green"
                            }}
                            className="view-button" onClick={() => patientSelected('VIEW', patient)}>< /></button> */}
                          {/* <button className="delete-button" onClick={() => patientSelected('DELETE', patient)}><DeleteIcon /></button> */}
                          {/* <button className="info-button" onClick={() => patientSelected('DETAIL', patient)}><Info fill="" /></button> */}
                        </div>
                      </div>
                      <div className="contact-wrapper px-4">
                        <div>
                          <p className="title">EMERGENCY CONTACT NAME</p>
                          <p className="value">{patient.EmergencyName}</p>
                        </div>
                        <div>
                          <p className="title">EMERGENCY CONTACT NUMBER</p>
                          <p className="value">{patient.EmergencyPhone}</p>
                        </div>
                      </div>
                      <div className="card-footer d-flex justify-content-between">
                        <div className="">
                          <p className="title">FACILITY NAME</p>
                          <p className="value">
                            {patient.FacilityName}
                            {patient.facilityParentCompany && ` - ${patient.facilityParentCompany}`}
                          </p>
                        </div>
                        <div className="room-count w-50">
                          <p className="title">ROOM</p>
                          <p className="value">{patient.Room}</p>
                        </div>
                        {/* <div className="diagnosis">
                            <p className="title">DIAGNOSIS</p>
                            <p className="value">{patient.Diagnosis}</p>
                          </div> */}
                      </div>
                    </div>
                  ))}

                {filteredPatientData.length === 0 && <h6 className="d-flex justify-content-center text-secondary">No Patient found</h6>}
              </div>
            )}

            {boxView === 'table' && renderedPatientList}

            <CModal
              size="lg"
              visible={modalVisible}
              className="dashboard-dark-modal patient-theme-modal"
              data-theme={patientTheme}
            // onClose={resetStates}
            >
              <CModalBody className="patient-theme-modal-body" style={{ padding: '2rem' }}>
                <CNav variant="pills" role="tablist" className="justify-content-center">
                  <CNavItem>
                    <CNavLink href="#" active={activeTab === 'patientDetails'} onClick={() => setActiveTab('patientDetails')}>
                      Patient Details
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink href="#" active={activeTab === 'other'} onClick={() => setActiveTab('other')}>
                      {/* mihir Added */}
                      Demographics
                    </CNavLink>
                  </CNavItem>

                  <CNavItem>
                    <CNavLink href="#" active={activeTab === 'insurance'} onClick={() => setActiveTab('insurance')}>
                      Insurance
                    </CNavLink>
                  </CNavItem>
                </CNav>
                <CTabContent>
                  <CTabPane role="tabpanel" visible={activeTab === 'patientDetails'}>
                    <div className="m-3">
                      <CFormLabel>Select Facility</CFormLabel>
                      <Select
                        placeholder="Select"
                        name="facility"
                        options={facilities}
                        value={selectedFacility}
                        onChange={(e) => {
                          setSelectedFacility(e)
                          const facilityType = String(e?.Type || e?.type || '').trim().toLowerCase()
                          if (facilityType !== 'snf') {
                            setChildFormData((prev) => ({ ...prev, patientType: '' }))
                          }
                          if (facilityType !== 'ccrc') {
                            setChildFormData((prev) => ({ ...prev, services: '' }))
                          }
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    </div>
                    <div className="m-3  d-none">
                      <CFormLabel>Facility Type</CFormLabel>
                      <CFormInput value={selectedFacilityType || 'N/A'} disabled style={{ fontSize: '14px', backgroundColor: '#f3f3f3' }} />
                    </div>
                    {isCCRCFacility  && (
                      <div className="m-3">
                        <CFormLabel>Services</CFormLabel>
                        <Select
                          name="service"
                          options={serviceOptions}
                          value={serviceOptions.find((option) => option.value === childformData.services) || null}
                          onChange={(option) => {
                            setChildFormData((prevData) => ({
                              ...prevData,
                              services: option?.value || '',
                            }))
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </div>
                    )}
                    {showPatientType && (
                      <div className="m-3">
                        <CFormLabel>Patient Type</CFormLabel>
                        <Select
                          name="patientType"
                          options={patientTypeOptions}
                          value={patientTypeOptions.find((option) => normalizePatientType(option.value) === normalizePatientType(childformData.patientType)) || null}
                          onChange={(option) => {
                            setChildFormData((prevData) => ({
                              ...prevData,
                              patientType: option?.value || '',
                            }))
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                        {formValidationErrors?.patientType && <small style={{ color: 'red' }}>{formValidationErrors?.patientType}</small>}
                      </div>
                    )}
                    {/* <div className="m-3">
                          <CFormLabel>Select Status</CFormLabel>
                          <Select
                            placeholder="Select"
                            name="status"
                            options={patientStatus}
                            defaultValue={selectedStatusPatient}
                            onChange={(e) => {
                              setSelectedStatusPatient(e)
                            }}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </div> */}

                    <div className="m-3">
                      <CFormLabel>Room Number</CFormLabel>
                      <CFormInput value={roomNumber} onChange={(e) => setRoomNumber(e.target.value)} placeholder="Room Number" style={{ fontSize: '14px' }} />
                      {formValidationErrors?.roomNumber && <small className="patient-theme-error">{formValidationErrors?.roomNumber}</small>}
                    </div>

                    <div className="m-3">
                      <CFormLabel>Status</CFormLabel>

                      <Select
                        name="Status"
                        onChange={(e) => {
                          setChildFormData((prevData) => ({
                            ...prevData,
                            Status: e.value,
                          }))
                        }}
                        value={selectedOptionStatus}
                        options={selectStatusOption}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    </div>
                    {/* <div className="m-3">
                          <CFormLabel>Select Diagnosis</CFormLabel>
                          <Select
                            placeholder="Select"
                            isMulti
                            name="diagnosis"
                            defaultValue={allSelectedDiagnosis}
                            onChange={(e) => {
                              selectedDiagnosis = e;
                              setAllSelectedDiagnosis([...e])
                            }}
                            options={diagnosisData}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </div> */}
                  </CTabPane>
                  <CTabPane role="tabpanel" visible={activeTab === 'other'}>
                    <div className="m-3">
                      <AddPatientForm formData={childformData} setFormData={setChildFormData} errors={formValidationErrors} />
                    </div>
                  </CTabPane>
                  <CTabPane role="tabpanel" visible={activeTab === 'insurance'}>
                    <InsuranceTab childformData={childformData} Credentialed={'hidden'} addedInsurances={addedInsurances} setAddedInsurances={setAddedInsurances} selectedDetails={selectedDetails} insuranceList={insuranceList} insuranceTypes={insuranceTypes} />
                  </CTabPane>
                </CTabContent>
              </CModalBody>
              <CModalFooter>
                <Button
                  variant="outlined"
                  onClick={() => {
                    resetStates(), setPatientID('')
                  }}
                >
                  Close
                </Button>
                <Button
                  disabled={creatingPatientLoader}
                  variant="contained"
                  onClick={() => {
                    saveDiagnosisData()
                  }}
                >
                  {' '}
                  {creatingPatientLoader ? <CircularProgress className="text-white p-1" size={20} /> : 'Submit'}
                </Button>
              </CModalFooter>
            </CModal>

            <CModal size="lg" visible={viewModalVisible} onClose={() => setViewModalVisible(false)} className="dashboard-dark-modal patient-theme-modal" data-theme={patientTheme}>
              <CModalBody className="view-data-modal" style={{ padding: '2rem', borderRadius: '2rem' }}>
                <CNav variant="pills" role="tablist" className="justify-content-center">
                  <CNavItem>
                    <CNavLink href="#" active={activeTab === 'patientDetails'} onClick={() => setActiveTab('patientDetails')}>
                      Patient Details
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink href="#" active={activeTab === 'other'} onClick={() => setActiveTab('other')}>
                      Demographics
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink href="#" active={activeTab === 'insurance'} onClick={() => setActiveTab('insurance')}>
                      Insurance
                    </CNavLink>
                  </CNavItem>
                </CNav>
                {viewPatientDetail && (
                  <CTabContent>
                    <CTabPane role="tabpanel" visible={activeTab === 'patientDetails'}>
                      <div className="form-group">
                        <label>Selected Facility</label>
                        <span className="value">
                          {viewPatientDetail.FacilityName || '-'}
                          {getPatientFacilityParentCompany(viewPatientDetail, facilities) && ` - ${getPatientFacilityParentCompany(viewPatientDetail, facilities)}`}
                        </span>
                      </div>
                      <div className="form-group">
                        <label>Facility Type</label>
                        <span className="value">{getFacilityTypeForPatient(viewPatientDetail) || 'N/A'}</span>
                      </div>
                      <div className="form-group">
                        <label>Patient Type</label>
                        <span className="value">{getPatientTypeForPatient(viewPatientDetail) || 'N/A'}</span>
                      </div>
                      <div className="form-group">
                        <label>Room Number</label>
                        <span className="value">{viewPatientDetail.Room || '-'}</span>
                      </div>
                      <div className="form-group">
                        <label>Patient Status</label>
                        <span className="value">{viewPatientDetail.Status || '-'}</span>
                      </div>
                    </CTabPane>
                    <CTabPane className="personal-detail" role="tabpanel" visible={activeTab === 'other'}>
                      <div className="form-group">
                        <label>First Name</label>
                        <span className="value">{viewPatientDetail.FirstName || '-'}</span>
                      </div>
                      <div className="form-group">
                        <label>Middle Name</label>
                        <span className="value">{viewPatientDetail.MiddleName || '-'}</span>
                      </div>
                      <div className="form-group">
                        <label>Last Name</label>
                        <span className="value">{viewPatientDetail.LastName || '-'}</span>
                      </div>
                      <div className="form-group">
                        <label>Date of Birth</label>
                        <span className="value">{viewPatientDetail.DOB || '-'}</span>
                      </div>
                      <div className="form-group">
                        <label>Gender</label>
                        <span className="value">{viewPatientDetail.Gender || '-'}</span>
                      </div>
                      <div className="form-group">
                        <label>Age</label>
                        <span className="value">{viewPatientDetail.Age || '-'}</span>
                      </div>
                      <div className="form-group">
                        <label>Emergency Contact Name</label>
                        <span className="value">{viewPatientDetail.EmergencyName || '-'}</span>
                      </div>
                      <div className="form-group">
                        <label>Emergency Contact Phone</label>
                        <span className="value">{viewPatientDetail.EmergencyPhone || '-'}</span>
                      </div>
                    </CTabPane>
                    <CTabPane role="tabpanel" visible={activeTab === 'insurance'}>
                      {selectedDetails?.Insurances?.length > 0 ? (
                        selectedDetails.Insurances.map((item, index) => {
                          const insurance = parseInsuranceDetails(item?.InsuranceDetails)

                          return (
                            <div key={index} className="mb-3">
                              <div className="form-group">
                                <label>Policy Number</label>
                                <span className="value">{insurance?.PolicyNumber || '-'}</span>
                              </div>

                              <div className="form-group">
                                <label>Insurance Type</label>
                                <span className="value">{insurance?.Type || '-'}</span>
                              </div>

                              <div className="form-group">
                                <label>Insurance SubType</label>
                                <span className="value">{insurance?.SubType || '-'}</span>
                              </div>
                            </div>
                          )
                        })
                      ) : (
                        <span className="value">No Insurance Found</span>
                      )}
                    </CTabPane>
                  </CTabContent>
                )}
              </CModalBody>
              <CModalFooter>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setViewModalVisible(false), setPatientID('')
                  }}
                >
                  Close
                </Button>
                <Button variant="contained" onClick={() => saveDiagnosisData()}>
                  Submit
                </Button>
              </CModalFooter>
            </CModal>

            <CModal size="lg" visible={patientModelVisible} onClose={() => setPatientModalVisible(false)} className="dashboard-dark-modal patient-theme-modal" data-theme={patientTheme}>
              <CModalBody className="view-data-modal" style={{ padding: '2rem', borderRadius: '2rem', overflow: 'auto' }}>
                {
                  <PatientPopup
                    patientID={patientIDClicked}
                    patientData={rowClicked}
                    setPatientModalVisible={setPatientModalVisible}
                    dataCallType={dataCallType}
                    setDataCallType={setDataCallType}
                    setEditDataId={setEditDataId}
                    setShowPatientInfo={setShowPatientInfo}
                    setNoteID={setNoteID}
                    patientSelected={patientSelected}
                    childformData={childformData}
                    setChildFormData={setChildFormData}
                    saveDiagnosisData={saveDiagnosisData}
                    resetStates={resetStates}
                  />
                }
              </CModalBody>
              <CModalFooter>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setPatientModalVisible(false), resetStates(), setPatientID('')
                  }}
                >
                  Close
                </Button>
              </CModalFooter>
            </CModal>

            <CModal
              visible={deleteVisible}
              backdrop="static"
              keyboard={false}
              className="dashboard-dark-modal patient-theme-modal"
              data-theme={patientTheme}
              onClose={() => {
                if (!deleteLoader) {
                  setDeleteVisible(false)
                }
              }}
            >
              <CModalHeader>
                <CModalTitle>Warning</CModalTitle>
              </CModalHeader>
              <CModalBody>
                <p>Are you sure you want to delete?</p>
              </CModalBody>

              <CModalFooter>
                <CButton
                  onClick={() => {
                    setDeleteVisible(false)
                  }}
                  className="text-white"
                  color="secondary"
                >
                  Close
                </CButton>
                <CButton
                  onClick={handleDeletePatient}
                  className="text-white d-inline-flex align-items-center justify-content-center"
                  color="danger"
                  disabled={deleteLoader}
                  style={{ minWidth: '92px' }}
                >
                  {deleteLoader ? <CircularProgress size={20} color="inherit" /> : 'Delete'}
                </CButton>
              </CModalFooter>
            </CModal>

            <CModal
              size="xl"
              visible={allPatientVisible}
              className="dashboard-dark-modal patient-theme-modal patient-all-data-modal"
              data-theme={patientTheme}
              onClose={() => {
                setAllPatientVisible(false), setShowNotePatient(false)
              }}
            >
              <CModalHeader>
                <CModalTitle>Patient All Data</CModalTitle>
              </CModalHeader>
              <CModalBody>
                <PatientAllDetails
                  key={`${viewPatientDetail?.PatientID || 'patient'}-${allPatientVisible ? 'open' : 'closed'}`}
                  viewPatientDetail={viewPatientDetail}
                  selectedDetails={selectedDetails}
                  showNotePatient={showNotePatient}
                  setShowNotePatient={setShowNotePatient}
                />
              </CModalBody>

              <CModalFooter>
                <CButton
                  onClick={() => {
                    setAllPatientVisible(false)
                    setShowNotePatient(false)
                  }}
                  className="text-white"
                  color="secondary"
                >
                  Close
                </CButton>
              </CModalFooter>
            </CModal>
          </div>

          <CModal backdrop="static" visible={samePatientExist} onClose={() => setSamePatientExist(false)} aria-labelledby="StaticBackdropExampleLabel" className="dashboard-dark-modal patient-theme-modal" data-theme={patientTheme}>
            <CModalHeader>
              <CModalTitle id="StaticBackdropExampleLabel">Patient Already Exist</CModalTitle>
            </CModalHeader>
            <CModalBody>A patient with the same credentials already exists in the system. Please review carefully before proceeding to avoid duplicate records.</CModalBody>
            <CModalFooter>
              <CButton color="danger" variant="outline" onClick={() => setSamePatientExist(false)}>
                Close
              </CButton>
            </CModalFooter>
          </CModal> 
        </div>
      )}
    </div>
  )
}
export default Patient
